import React from 'react';
import PropTypes from 'prop-types';

const ImageForCard = ({ imageSrc, altValue }) => {
    if (!imageSrc) return null;
    return <img src={imageSrc} alt={altValue} className="card-with-image__picture" />;
};

ImageForCard.propTypes = {
    imageSrc: PropTypes.string,
    altValue: PropTypes.string,
};
export default ImageForCard;
